import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*global google*/
import React from 'react';
import { Marker, InfoWindow } from 'react-google-maps';
import MarkerPopover from './MarkerPopover';
import storePin from 'src/assets/storelocatorpin-icon.png';

var StoreMarker = function StoreMarker(props) {
  var store = props.store;
  return React.createElement(Marker, {
    icon: {
      url: storePin,
      scaledSize: new google.maps.Size(32, 36)
    },
    key: "store-locator-marker-store-id-".concat(store.store_id),
    onClick: function onClick() {
      props.setShownStores(_objectSpread(_objectSpread({}, props.shownStore), {}, _defineProperty({}, store.store_id, !props.shownStores[store.store_id])));
      props.setNewPosition({
        lat: store.lat,
        lng: store.lng
      });
    },
    position: {
      lat: store.lat,
      lng: store.lng
    }
  }, props.shownStores[store.store_id] && React.createElement(InfoWindow, {
    onCloseClick: function onCloseClick() {
      props.setShownStores(_objectSpread(_objectSpread({}, props.shownStores), {}, _defineProperty({}, store.store_id, !props.shownStores[store.store_id])));
    }
  }, React.createElement(MarkerPopover, _extends({}, props, {
    store: store
  }))));
};

export default StoreMarker;